<template>
  <div class="gf-field">
    <div class="autoresize-textarea">
      <textarea v-model="componentValue" :placeholder="placeholder"></textarea>
      <div class="autoresize-content" v-html="htmlValue"></div>
    </div>
  </div>
</template>

<script>
import { componentMixin } from './FormCommon'

export default {
  props: ["placeholder"],
  mixins: [componentMixin],
  computed: {
    htmlValue() {
      return (this.componentValue || "").
        replace(/&/g, "&amp;").
        replace(/\</g, "&lt;").
        replace(/\>/g, "&gt;").
        replace(/"/g, "&quot;").
        replace(/\n/g, "<br>")+"<br>";
    },
  },
}
</script>
